import { useEffect, useState } from 'react';
import './CookieConsent.css';

const GTM_CONTAINER_ID = process.env.REACT_APP_GTM_CONTAINER_ID || 'GTM-NT6FZJRD';
const COOKIE_NAME = 'cookieConsent';
const COOKIE_MAX_AGE_DAYS = 730; // 2 years

let gtmInitialized = false;

function initTagManager() {
  if (gtmInitialized) return;
  if (!GTM_CONTAINER_ID) return;

  gtmInitialized = true;

  // Initialize dataLayer and push gtm.start event
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': Date.now(),
    event: 'gtm.js',
  });

  // Load GTM script
  const existingScript = document.querySelector(
    `script[src^="https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}"]`
  );
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_CONTAINER_ID}&l=dataLayer`;
    document.head.appendChild(script);
  }
}

function getConsentFromCookie() {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`));
  if (!match) return null;
  return decodeURIComponent(match.split('=')[1]);
}

function setConsentCookie(value) {
  if (typeof document === 'undefined') return;
  const expires = new Date(
    Date.now() + COOKIE_MAX_AGE_DAYS * 24 * 60 * 60 * 1000
  ).toUTCString();
  document.cookie = `${COOKIE_NAME}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; SameSite=Lax`;
}

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    try {
      const stored = getConsentFromCookie();
      if (stored === 'accepted') {
        initTagManager();
        setIsVisible(false);
      } else if (stored === 'rejected') {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    } catch {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setConsentCookie('accepted');
    initTagManager();
    setIsVisible(false);
  };

  const handleReject = () => {
    setConsentCookie('rejected');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-consent__content">
        <div className="cookie-consent__text">
          <h2 className="cookie-consent__title">Mogen we cookies zetten?</h2>
          <p className="cookie-consent__description">
            We gebruiken een paar koekjes om te zien hoe je onze webcam&nbsp;site gebruikt, zodat we
            &apos;m nog beter kunnen maken. We plaatsen alleen statistiekcookies als je op
            &quot;Accepteren&quot; klikt.
          </p>
        </div>
        <div className="cookie-consent__actions">
          <button
            type="button"
            className="cookie-consent__button cookie-consent__button--secondary"
            onClick={handleReject}
          >
            Weigeren
          </button>
          <button
            type="button"
            className="cookie-consent__button cookie-consent__button--primary"
            onClick={handleAccept}
          >
            Accepteren
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;

